import { Link, ModalBody, ModalFooter } from "@heroui/react";
import { useCallback } from "react";

import { type DialogData } from "../../contexts/DialogContext";
import { Button } from "../core/Button";

export const Normal = ({
  state,
}: {
  state: DialogData<"LOGIN_INFO"> & { mode: "NORMAL" };
}) => {
  const WelcomeStep = useCallback(
    () => (
      <>
        <h1 className="text-2xl font-bold text-center">Welcome to Canvas!</h1>
        <p>
          Canvas is built by{" "}
          <Link href="https://fediverse.events" target="_blank">
            fediverse.events
          </Link>{" "}
          for the Fediverse!
        </p>
        <h2 className="text-xl">What is the Fediverse?</h2>
        <div
          style={{
            position: "relative",
            paddingTop: "56.25%",
          }}
        >
          <iframe
            title="Introducing the Fediverse: a New Era of Social Media"
            width="100%"
            height="100%"
            src="https://videos.elenarossini.com/videos/embed/64VuNCccZNrP4u9MfgbhkN"
            allowFullScreen
            sandbox="allow-same-origin allow-scripts allow-popups allow-forms"
            style={{
              position: "absolute",
              inset: "0",
            }}
          ></iframe>
        </div>
        <p className="flex gap-1 flex-wrap text-sm">
          <strong>Video not working?</strong>
          <Link
            href="https://videos.elenarossini.com/w/64VuNCccZNrP4u9MfgbhkN"
            target="_blank"
            className="text-sm"
          >
            Open Directly
          </Link>{" "}
          &bull;{" "}
          <Link
            href="https://sc07.tv/w/64VuNCccZNrP4u9MfgbhkN"
            target="_blank"
            className="text-sm"
          >
            Mirror (sc07.tv)
          </Link>
        </p>
      </>
    ),
    [],
  );

  return (
    <>
      <ModalBody>
        <WelcomeStep />
      </ModalBody>
      <ModalFooter>
        {/* we have both here to avoid confusing people */}
        <Button as={Link} href={state.url}>
          Register
        </Button>
        <Button as={Link} href={state.url}>
          Login
        </Button>
      </ModalFooter>
    </>
  );
};
